import { CompareOrder } from './CompareOrder';
import { compareUndefined } from './compareUndefined';

export function compareGreater<T>(a: T, b: T, handleUndefined: CompareOrder = CompareOrder.Equal): CompareOrder {
	// Values are the same
	if (a === b) {
		return CompareOrder.Equal;
	}

	// Check if we should sort based on undefined values
	const undefinedComparison = compareUndefined(a, b, handleUndefined);
	if (undefinedComparison !== CompareOrder.Equal) {
		return undefinedComparison;
	}

	if (a > b) {
		return CompareOrder.Before;
	}

	if (b > a) {
		return CompareOrder.After;
	}

	return CompareOrder.Equal;
}
